// import WelcomeToCustomers from '@features/customers/components/WelcomeToCustomers';
import useSearch from '@features/customers/hooks/search.hook';
import ContainerProps from '@interfaces/container.interface';
import { Grid } from '@mui/material';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SearchBar from '../../components/SearchBar';
import useUsersContainerStyles from './UsersContainer.styles';
import { parse as queryString } from 'query-string';
import SearchFilters from '@features/customers/constants/search-filters.enum';
import { CUSTOMERS_PATH } from '@constants/paths.constant';
import InfoIcon from '@mui/icons-material/Info';
import PersonIcon from '@mui/icons-material/Person';
import RequestsTable from '@features/customers/components/RequestsTable/RequestsTable';

const Users: React.FC<ContainerProps> = ({ menuState }) => {
	// Hooks
	const classes = useUsersContainerStyles();
	const location = useLocation();
	const navigate = useNavigate();
	const search = useSearch();

	const [esSolicitudes, setEsSolicitudes] = useState(true);
	const [notFoundCorreo, setNotFoundCorreo] = useState(false);
	const { search: searchQuery } = queryString(location.search);

	// Effects
	useEffect(() => {
		try {
			if (location.search && location.search.length > 0) {
				const {
					division: queryDivision,
					filter: queryFilter,
					search: querySearch,
				} = queryString(location.search);

				if (typeof queryFilter === 'string' && typeof querySearch === 'string') {
					const realFilter = Object.entries(SearchFilters).find(
						([, value]) => value === queryFilter
					);

					if (!realFilter) {
						navigate(CUSTOMERS_PATH);
						throw new Error('El filtro proveniente de la query no es válido.');
					}

					if (!search.verifyText(querySearch, realFilter[1])) {
						navigate(CUSTOMERS_PATH);
						throw new Error(
							'El texto de búsqueda proveniente de la query no es válido.'
						);
					}

					if (search.text.toLowerCase() === querySearch.toLowerCase()) {
						return;
					}

					search.handleSearchPressed(undefined, querySearch, realFilter[1]);

					if (typeof queryDivision === 'string') {
						search.setDivisionNumber(queryDivision);
					} else {
						search.setDivisionNumber('');
					}
				}
			} else if (search.data || search.text.length > 0) {
				search.reset();
			}
		} catch (e) {
			console.error('Location search', e);

			if (search.data || search.text.length > 0) {
				search.reset();
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);

	useEffect(() => {
		document?.getElementById('gestionar_clientes_')?.addEventListener(
			'click',
			() => {
				search.reset();
			},
			false
		);
	}, [search]);

	/*
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};
	*/

	return (
		<>
			<Grid container id="customers-container">
				<Grid item xs={12}>
					<div
						className={clsx(classes.headerContainer, {
							[classes.headerContainerBig]: menuState === 'big',
							[classes.headerContainerSmall]: menuState === 'small',
						})}
					>
						<SearchBar
							data={search.autocompleteData}
							filter={search.filter}
							handleAutocompleteSearch={search.handleAutocompleteSearch}
							handleSearchPressed={search.handleSearchPressed}
							loading={search.autocompleteLoading}
							needAutocomplete={search.needAutocomplete}
							searchText={search.autocompleteText}
							setNeedAutocomplete={search.setNeedAutocomplete}
							verifyText={search.verifyText}
							handleChangeFilter={search.handleChangeFilter}
							setValueEmail={search.setValueEmail}
							valueEmail={search.valueEmail}
						/>
					</div>
				</Grid>
				{!notFoundCorreo && (
					<Grid item xs={12}>
						<div className={classes.elementContainer}>
							<div
								role="button"
								tabIndex={0}
								className={classes.tab}
								onClick={() => {
									setEsSolicitudes(true);
								}}
								style={{ backgroundColor: esSolicitudes ? '#FFFFFF' : '#FAFAFA' }}
							>
								<InfoIcon
									sx={{
										float: 'left',
										color: esSolicitudes ? '#1063AC' : '#686868',
										marginLeft: '70px',
										marginRight: '6px',
										marginTop: '14px !important',
									}}
								/>
								<p
									style={{
										color: esSolicitudes ? '#1063AC' : '#686868',
									}}
								>
									Solicitudes{' '}
								</p>
								{esSolicitudes && <div className={classes.separador}></div>}
							</div>
							<div
								role="button"
								tabIndex={0}
								className={classes.tab}
								onClick={() => {
									setEsSolicitudes(false);
								}}
								style={{ backgroundColor: esSolicitudes ? '#FAFAFA' : '#FFFFFF' }}
							>
								<PersonIcon
									sx={{
										float: 'left',
										color: esSolicitudes ? '#686868' : '#1063AC',
										marginLeft: '80px',
										marginRight: '6px',
										marginTop: '14px !important',
									}}
								/>
								<p
									style={{
										color: esSolicitudes ? '#686868' : '#1063AC',
									}}
								>
									Usuarios
								</p>
								{!esSolicitudes && <div className={classes.separador}></div>}
							</div>
							<div className={classes.container}>
								{esSolicitudes ? (
									<>
										<RequestsTable
											notFoundCorreo={notFoundCorreo}
											setNotFoundCorreo={setNotFoundCorreo}
										></RequestsTable>
									</>
								) : (
									<></>
								)}
							</div>
						</div>
					</Grid>
				)}
				{notFoundCorreo && (
					<Grid item xs={12}>
						<div className={classes.containerNotFound}>
							<img
								className={classes.notFoundImg}
								src="/IconNotFoundUsers.svg"
								alt="notFound"
							/>
							<h2 className={classes.notFoundTitle}>No se encontraron resultados</h2>
							<p className={classes.p}>
								La búsqueda de <strong>{searchQuery}</strong> no obtuvo ninguna
								coincidencia
							</p>
							<p className={classes.p}>Intenta realizando otra búsqueda</p>
						</div>
					</Grid>
				)}
			</Grid>
		</>
	);
};

export default Users;
